export const muiDrawer = { 
    styleOverrides: {
        paper:{
            width: 180
        }
    }
}